/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AssignedDevice = {
  /**
   * Serial number of the assigned device.
   */
  serialNumber: string;
  status: AssignedDevice.status;
  /**
   * Reason why device failed to assign to tenant.
   */
  errorMessage?: string;
};
export namespace AssignedDevice {
  export enum status {
    IN_PROGRESS = 'IN_PROGRESS',
    ASSIGNED = 'ASSIGNED',
    NOT_ASSIGNED = 'NOT_ASSIGNED',
  }
}

